import { FormControl, InputGroup } from 'react-bootstrap';
import { Icon } from '../index';
import displayCurrency from '../../../helpers/displayCurrency';
import React from 'react';

const AddonContainers = ({
  addonBefore,
  addonAfter,
  monetaryValue,
  currency,
  percentage,
  isCalc,
  children,
}) => {
  if (addonBefore || addonAfter || monetaryValue || currency || percentage) {
    return (
      <InputGroup>
        {currency && (
          <InputGroup.Addon>
            <Icon name={isCalc ? 'spinner' : 'pound-sign'} spin={isCalc} />
          </InputGroup.Addon>
        )}
        {percentage && (
          <InputGroup.Addon>
            <Icon name={isCalc ? 'spinner' : 'percent'} spin={isCalc} />
          </InputGroup.Addon>
        )}
        {!!addonBefore && <InputGroup.Addon>{addonBefore}</InputGroup.Addon>}

        {children}
        {!!monetaryValue && (
          <InputGroup.Addon className="monetary-value">
            {displayCurrency(monetaryValue)}
          </InputGroup.Addon>
        )}

        {!!addonAfter && <InputGroup.Addon>{addonAfter}</InputGroup.Addon>}
      </InputGroup>
    );
  }
  return <>{children}</>;
};

const filterCurrency = (value) => {
  if (value === undefined) {
    return '';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const FormControlInput = ({
  value,
  type,
  rows,
  disabled,
  className,
  addonBefore,
  addonAfter,
  monetaryValue,
  currency,
  percentage,
  isCalc,
  placeholder,
  onChange,
  onBlur,
  readOnly,
}) => {
  const handleOnChange = (event) => {
    const eventValue = event?.target?.value;

    const newValue = currency ? eventValue?.replace(/[^\d.-]/g, '') : event.target.value;

    if (onChange) {
      onChange(newValue);
    }
  };

  const handleOnBlur = (event) => {
    const eventValue = event?.target?.value;

    const newValue = currency ? eventValue?.replace(/[^\d.-]/g, '') : event.target.value;

    if (onBlur) {
      onBlur(newValue);
    }
  };

  return (
    <>
      <AddonContainers
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        monetaryValue={monetaryValue}
        currency={currency}
        percentage={percentage}
        isCalc={isCalc}
      >
        <FormControl
          type={type}
          className={className}
          placeholder={currency ? filterCurrency(placeholder) : placeholder}
          value={currency ? filterCurrency(value) : value}
          rows={rows}
          disabled={disabled}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          readOnly={readOnly}
        />
      </AddonContainers>
    </>
  );
};

export default FormControlInput;
